module.exports = __webpack_public_path__ + "static/fonts/montserrat-medium.a98626e.ttf";